var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.preventMiddleClick
    ? _c(
        "a",
        {
          attrs: { href: "javascript:void(0);", "data-href": "href" },
          on: {
            click: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
              _vm.show(), _vm.$emit("get-result", $event)
            },
            mouseup: function($event) {
              if ("button" in $event && $event.button !== 1) {
                return null
              }
              $event.preventDefault()
              return _vm.showMiddle.apply(null, arguments)
            }
          }
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "a",
        {
          attrs: { href: _vm.href },
          on: {
            click: function($event) {
              $event.preventDefault()
              $event.stopPropagation()
              _vm.show(), _vm.$emit("get-result", $event)
            }
          }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47bcb65c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bcb65c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VModalLink.vue
// module id = 267
// module chunks = 1 2